"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkTheme = exports.lightTheme = void 0;
exports.lightTheme = {
    themeName: "light",
    background: "rgba(252,253,254,1)",
    blueLight: "rgba(89,180,245,1)",
    blue: "rgba(17,147,240,1)",
    blueDark: "rgba(11,103,170,1)",
    black: "rgba(33,33,33,1)",
    steel: "rgba(87,87,87,1)",
    concrete: "rgba(153,153,153,1)",
    smokeDarker: "rgba(192,204,218,1)",
    smokeDark: "rgba(211,220,230,1)",
    smoke: "rgba(224,230,237,1)",
    snowDarker: "rgba(229,233,242,1)",
    snowDark: "rgba(239,242,247,1)",
    snow: "rgba(249,250,252,1)",
    success: "rgba(32,175,90,1)",
    danger: "rgba(245,0,50,1)",
    dangerDark: "rgba(219, 0, 45, 1)",
    warning: "rgba(251,181,43,1)",
    greenLight: "rgba(210, 255, 174, 1)",
    green: "rgba(63,220,127,1)",
    greenDark: "rgba(32,175,90,1)",
    turquoiseLight: "rgba(133,227,240,1)",
    turquoise: "rgba(65,211,231,1)",
    turquoiseDark: "rgba(25,174,195,1)",
    turquoise15: "rgba(25,174,195,0.15)",
    turquoise30: "rgba(25,174,195,0.30)",
    pinkLight: "rgba(255,143,166,1)",
    pink: "rgba(255,67,105,1)",
    pinkDark: "rgba(245,0,50,1)",
    cyanLight: "rgba(241,253,255,1)",
    whaleLight: "rgba(126,140,148,1)",
    whale: "rgba(61,93,116,1)",
    whaleDark: "rgba(48,74,98,1)",
    white: "rgba(252,253,254,1)",
    meteor: "rgba(5, 146, 166, 1)",
    navy: "rgba(241, 243, 247)",
    ozone: "rgba(225, 251, 255, 1)",
    gold: "rgba(224, 157, 26, 1)",
    goldLight: "rgba(255, 247, 206, 1)",
    redDark: "rgba(174, 33, 33, 1)",
    redDark10: "rgba(174, 33, 33, 0.1)",
    redLight: "rgba(255, 226, 216, 1)",
    lake: "rgba(208, 229, 234, 1)",
    perfGreen: "rgba(9, 47, 50, 1)",
    attention: "rgba(250,208,127,1)",
    turquoise80: "rgba(25,174,195,0.80)",
    danger80: "rgba(245,0,50,0.80)",
    attention15: "rgba(250,208,127,0.15)",
    attention40: "rgba(250,208,127,0.40)",
    snowDarker25: "rgba(229,233,242,0.25)",
    danger5: "rgba(245,0,50,0.05)",
    danger15: "rgba(245,0,50,0.15)",
    danger40: "rgba(245,0,50,0.40)",
    turquoise5: "rgba(25,174,195,0.05)",
    purple: "rgba(139, 127, 255, 1)",
    purple15: "rgba(139, 127, 255, 0.15)",
    purple40: "rgba(139, 127, 255, 0.40)",
};
exports.darkTheme = {
    themeName: "dark",
    background: "rgba(26,26,26,1)",
    blueLight: "rgba(169,211,242,1)",
    blue: "rgba(102,178,232,1)",
    blueDark: "rgba(36,145,222,1)",
    turquoiseLight: "rgba(206,239,244,1)",
    turquoise: "rgba(143,219,230,1)",
    turquoiseDark: "rgba(80,199,216,1)",
    turquoise15: "rgba(25,174,195,0.15)",
    turquoise30: "rgba(25,174,195,0.30)",
    greenLight: "rgba(210, 255, 174, 1)",
    green: "rgba(139,221,172,1)",
    greenDark: "rgba(80,204,130,1)",
    danger: "rgba(249,102,132,1)",
    dangerDark: "rgba(249,102,132,1)",
    warning: "rgba(255,216,140,1)",
    success: "rgba(139,221,172,1)",
    snow: "rgba(33,33,33,1)",
    snowDark: "rgba(58,58,58,1)",
    snowDarker: "rgba(84,84,84,1)",
    smoke: "rgba(59,62,65,1)",
    smokeDark: "rgba(83,87,92,1)",
    smokeDarker: "rgba(108,113,118,1)",
    whaleLight: "rgba(126,140,148,1)",
    whale: "rgba(61,93,116,1)",
    whaleDark: "rgba(137,156,166,1)",
    steel: "rgba(153,153,153,1)",
    concrete: "rgba(87,87,87,1)",
    black: "rgba(247,248,248,1)",
    white: "rgba(26,26,26,1)",
    pinkLight: "rgba(252,222,228,1)",
    pink: "rgba(247,151,171,1)",
    pinkDark: "rgba(242,80,114,1)",
    cyanLight: "rgba(241,253,255,1)",
    meteor: "rgba(5,146,166,1)",
    navy: "rgba(241, 243, 247)",
    ozone: "rgba(225, 251, 255, 1)",
    gold: "rgba(224, 157, 26, 1)",
    goldLight: "rgba(255, 247, 206, 1)",
    redDark: "rgba(174, 33, 33, 1)",
    redDark10: "rgba(174, 33, 33, 0.1)",
    redLight: "rgba(255, 226, 216, 1)",
    lake: "rgba(208, 229, 234, 1)",
    perfGreen: "rgba(9, 47, 50, 1)",
    attention: "rgba(250,208,127,1)",
    turquoise80: "rgba(25,174,195,0.80)",
    danger80: "rgba(245,0,50,0.80)",
    attention15: "rgba(250,208,127,0.15)",
    attention40: "rgba(250,208,127,0.40)",
    snowDarker25: "rgba(229,233,242,0.25)",
    danger5: "rgba(245,0,50,0.05)",
    danger15: "rgba(245,0,50,0.15)",
    danger40: "rgba(245,0,50,0.40)",
    turquoise5: "rgba(25,174,195,0.05)",
    purple: "rgba(139, 127, 255, 1)",
    purple15: "rgba(139, 127, 255, 0.15)",
    purple40: "rgba(139, 127, 255, 0.40)",
};
